/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plot the GC skew, (G−C)/(G+C), along a DNA sequence in windows, together with the cumulative skew. Shifts in cumulative GC skew often mark the replication origin and terminus of bacterial genomes.`)
};

const es_gcskew_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grafica el sesgo GC, (G−C)/(G+C), a lo largo de una secuencia de ADN en ventanas, junto con el sesgo acumulado. Los cambios en el sesgo GC acumulado a menudo marcan el origen y el terminal de replicación de los genomas bacterianos.`)
};

const de_gcskew_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plotten Sie den GC-Skew, (G−C)/(G+C), entlang einer DNA-Sequenz in Fenstern, zusammen mit dem kumulativen Skew. Verschiebungen im kumulativen GC-Skew markieren oft den Replikationsursprung und -terminus bakterieller Genome.`)
};

const nl_gcskew_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plot de GC-skew, (G−C)/(G+C), langs een DNA-sequentie in vensters, samen met de cumulatieve skew. Verschuivingen in cumulatieve GC-skew markeren vaak de replicatie-oorsprong en -terminus van bacteriële genomen.`)
};

const fr_gcskew_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracez le biais GC, (G−C)/(G+C), le long d'une séquence d'ADN par fenêtres, ainsi que le biais cumulé. Les changements de biais GC cumulé marquent souvent l'origine et le terminus de réplication des génomes bactériens.`)
};

const it_gcskew_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traccia lo skew GC, (G−C)/(G+C), lungo una sequenza di DNA in finestre, insieme allo skew cumulativo. I cambiamenti nello skew GC cumulativo spesso segnano l'origine di replicazione e il terminus dei genomi batterici.`)
};

const pt_br2_gcskew_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plote o GC skew, (G−C)/(G+C), ao longo de uma sequência de DNA em janelas, junto com o skew acumulado. Mudanças no GC skew acumulado frequentemente marcam a origem e o término de replicação de genomas bacterianos.`)
};

const pt_gcskew_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Represente graficamente a assimetria GC, (G−C)/(G+C), ao longo de uma sequência de ADN em janelas, juntamente com a assimetria cumulativa. As mudanças na assimetria GC cumulativa marcam frequentemente a origem e o término de replicação de genomas bacterianos.`)
};

const ja_gcskew_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNA配列に沿ったGCスキュー (G−C)/(G+C) を窓ごとにプロットし、累積スキューとともに表示します。累積GCスキューの変化は、細菌ゲノムの複製起点と終結点をよく示します。`)
};

const zh_gcskew_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以窗口方式沿 DNA 序列绘制 GC 偏斜 (G−C)/(G+C)，并同时显示累积偏斜。累积 GC 偏斜的转折点通常标志着细菌基因组的复制起点和终点。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_intro", locale)
	if (locale === "en") return en_gcskew_intro(inputs)
	if (locale === "es") return es_gcskew_intro(inputs)
	if (locale === "de") return de_gcskew_intro(inputs)
	if (locale === "nl") return nl_gcskew_intro(inputs)
	if (locale === "fr") return fr_gcskew_intro(inputs)
	if (locale === "it") return it_gcskew_intro(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_intro(inputs)
	if (locale === "pt") return pt_gcskew_intro(inputs)
	if (locale === "ja") return ja_gcskew_intro(inputs)
	return zh_gcskew_intro(inputs)
};